// Sepang pit lane: the driving line through the pit lane, from where it leaves our centreline
// in T15 to where it rejoins it before T1, with heights.
//
// GENERATED by scripts/sepang-pit.mjs; do not edit by hand. Regenerate with:
//   node scripts/sepang-pit.mjs [--osm <overpass.json | osm-api-map.xml>]
//
// Source: OpenStreetMap data (c) OpenStreetMap contributors, ODbL (https://www.openstreetmap.org/copyright),
// via the Overpass API (maps.mail.ru mirror) (2026-10-17): highway=raceway "Pit Lane" ways
// 23410526, 144359483 (entry node 1578189272 on the T15 way, exit node 253452230 on the
// Kuala Lumpur Straight) and the building way 144362327 ("Paddock / Pit Building") for the garages.
//
// Modifications (derived data, ODbL share-alike applies):
// - Projected into the sepang.ts frame (origin 2.760777 N 101.73715 E, rotation 0.212 deg, translation (-137.03, 0.52) m),
//   then shifted by the local offset between the OSM circuit and our centreline next to it (up to ~3 m on
//   the main straight, where our centreline is TUMFTM), so the pit lane keeps its place relative to the track.
// - Centripetal Catmull-Rom through the nodes, Gaussian smoothing sigma 4 m, resampled every 2 m.
// - The first 26 m and last 40 m are cubic Hermite blends that leave and rejoin our centreline
//   tangentially (position and heading continuous with the track).
// - y = SEPANG_ELEVATION interpolated at each point's projection onto the centreline.
//
// 497 points, 991.2 m. Entry junction at lap distance 5157.9 m, exit junction at 554.4 m.

/** Pit lane driving line in driving order: [x, z, y] metres (x east, z north, y height as SEPANG_ELEVATION). */
export const SEPANG_PIT_PATH: readonly (readonly [number, number, number])[] = [
  [355.715, -16.743, 0.42],
  [356.1, -14.782, 0.412],
  [356.552, -12.836, 0.405],
  [357.047, -10.9, 0.398],
  [357.565, -8.97, 0.391],
  [358.085, -7.04, 0.383],
  [358.588, -5.106, 0.377],
  [359.051, -3.162, 0.37],
  [359.453, -1.204, 0.363],
  [359.77, 0.769, 0.356],
  [359.976, 2.756, 0.345],
  [360.045, 4.753, 0.334],
  [359.949, 6.748, 0.33],
  [359.667, 8.726, 0.322],
  [359.237, 10.677, 0.315],
  [358.716, 12.606, 0.31],
  [358.116, 14.512, 0.305],
  [357.446, 16.395, 0.294],
  [356.715, 18.255, 0.282],
  [355.935, 20.095, 0.28],
  [355.126, 21.922, 0.272],
  [354.311, 23.747, 0.261],
  [353.509, 25.577, 0.25],
  [352.726, 27.416, 0.25],
  [351.96, 29.262, 0.244],
  [351.204, 31.112, 0.233],
  [350.446, 32.961, 0.223],
  [349.674, 34.804, 0.22],
  [348.879, 36.638, 0.22],
  [348.053, 38.457, 0.215],
  [347.193, 40.261, 0.209],
  [346.299, 42.049, 0.202],
  [345.374, 43.82, 0.2],
  [344.42, 45.576, 0.2],
  [343.442, 47.319, 0.198],
  [342.442, 49.049, 0.192],
  [341.418, 50.766, 0.186],
  [340.371, 52.467, 0.18],
  [339.295, 54.152, 0.18],
  [338.188, 55.815, 0.18],
  [337.045, 57.454, 0.179],
  [335.866, 59.068, 0.173],
  [334.65, 60.654, 0.167],
  [333.398, 62.211, 0.16],
  [332.111, 63.74, 0.16],
  [330.789, 65.238, 0.16],
  [329.428, 66.702, 0.16],
  [328.024, 68.124, 0.156],
  [326.565, 69.49, 0.15],
  [325.041, 70.782, 0.143],
  [323.446, 71.985, 0.14],
  [321.783, 73.092, 0.14],
  [320.064, 74.112, 0.14],
  [318.307, 75.064, 0.134],
  [316.528, 75.974, 0.127],
  [314.737, 76.86, 0.12],
  [312.937, 77.728, 0.12],
  [311.126, 78.573, 0.117],
  [309.297, 79.38, 0.113],
  [307.446, 80.133, 0.11],
  [305.569, 80.817, 0.11],
  [303.666, 81.426, 0.11],
  [301.74, 81.96, 0.11],
  [299.796, 82.422, 0.107],
  [297.836, 82.814, 0.103],
  [295.864, 83.133, 0.1],
  [293.88, 83.374, 0.096],
  [291.888, 83.528, 0.092],
  [289.891, 83.591, 0.09],
  [287.893, 83.558, 0.09],
  [285.899, 83.426, 0.09],
  [283.914, 83.196, 0.09],
  [281.943, 82.867, 0.09],
  [279.99, 82.443, 0.089],
  [278.058, 81.933, 0.085],
  [276.147, 81.351, 0.081],
  [274.252, 80.717, 0.08],
  [272.368, 80.049, 0.08],
  [270.49, 79.367, 0.08],
  [268.612, 78.683, 0.08],
  [266.732, 78.004, 0.08],
  [264.85, 77.333, 0.08],
  [262.965, 76.669, 0.08],
  [261.079, 76.009, 0.08],
  [259.191, 75.353, 0.08],
  [257.302, 74.7, 0.08],
  [255.413, 74.05, 0.08],
  [253.522, 73.401, 0.08],
  [251.631, 72.755, 0.08],
  [249.74, 72.11, 0.078],
  [247.848, 71.466, 0.074],
  [245.955, 70.824, 0.07],
  [244.063, 70.182, 0.07],
  [242.17, 69.541, 0.07],
  [240.277, 68.901, 0.07],
  [238.384, 68.261, 0.07],
  [236.49, 67.621, 0.07],
  [234.597, 66.982, 0.07],
  [232.704, 66.342, 0.07],
  [230.81, 65.703, 0.07],
  [228.916, 65.065, 0.07],
  [227.023, 64.426, 0.07],
  [225.129, 63.787, 0.07],
  [223.235, 63.149, 0.07],
  [221.342, 62.511, 0.07],
  [219.448, 61.872, 0.07],
  [217.554, 61.234, 0.07],
  [215.66, 60.596, 0.068],
  [213.766, 59.958, 0.064],
  [211.872, 59.32, 0.06],
  [209.979, 58.682, 0.06],
  [208.085, 58.044, 0.06],
  [206.191, 57.406, 0.06],
  [204.297, 56.768, 0.06],
  [202.403, 56.13, 0.06],
  [200.509, 55.492, 0.06],
  [198.615, 54.854, 0.06],
  [196.721, 54.216, 0.06],
  [194.828, 53.578, 0.06],
  [192.934, 52.94, 0.06],
  [191.04, 52.302, 0.06],
  [189.146, 51.664, 0.06],
  [187.252, 51.026, 0.06],
  [185.358, 50.387, 0.06],
  [183.465, 49.749, 0.06],
  [181.571, 49.111, 0.059],
  [179.677, 48.472, 0.055],
  [177.784, 47.833, 0.051],
  [175.89, 47.195, 0.05],
  [173.997, 46.556, 0.05],
  [172.103, 45.917, 0.05],
  [170.21, 45.277, 0.05],
  [168.316, 44.638, 0.05],
  [166.423, 43.998, 0.05],
  [164.53, 43.358, 0.05],
  [162.636, 42.718, 0.05],
  [160.743, 42.078, 0.05],
  [158.85, 41.437, 0.05],
  [156.958, 40.796, 0.05],
  [155.065, 40.155, 0.05],
  [153.172, 39.513, 0.05],
  [151.28, 38.87, 0.047],
  [149.388, 38.227, 0.043],
  [147.496, 37.583, 0.04],
  [145.605, 36.937, 0.04],
  [143.714, 36.29, 0.04],
  [141.824, 35.64, 0.04],
  [139.936, 34.985, 0.04],
  [138.05, 34.326, 0.04],
  [136.166, 33.659, 0.04],
  [134.283, 32.988, 0.04],
  [132.402, 32.315, 0.04],
  [130.518, 31.648, 0.04],
  [128.629, 30.996, 0.04],
  [126.731, 30.369, 0.04],
  [124.824, 29.772, 0.04],
  [122.907, 29.209, 0.04],
  [120.98, 28.679, 0.04],
  [119.045, 28.18, 0.04],
  [117.103, 27.708, 0.037],
  [115.155, 27.261, 0.033],
  [113.202, 26.837, 0.03],
  [111.244, 26.436, 0.03],
  [109.282, 26.057, 0.03],
  [107.316, 25.698, 0.03],
  [105.346, 25.36, 0.03],
  [103.374, 25.04, 0.03],
  [101.399, 24.735, 0.03],
  [99.422, 24.441, 0.03],
  [97.444, 24.153, 0.03],
  [95.466, 23.869, 0.03],
  [93.488, 23.583, 0.03],
  [91.511, 23.293, 0.03],
  [89.534, 22.999, 0.03],
  [87.558, 22.701, 0.03],
  [85.583, 22.4, 0.03],
  [83.607, 22.099, 0.029],
  [81.631, 21.803, 0.025],
  [79.653, 21.515, 0.021],
  [77.674, 21.239, 0.02],
  [75.692, 20.979, 0.02],
  [73.709, 20.737, 0.02],
  [71.722, 20.515, 0.02],
  [69.734, 20.312, 0.02],
  [67.745, 20.126, 0.02],
  [65.754, 19.953, 0.02],
  [63.762, 19.787, 0.02],
  [61.77, 19.623, 0.02],
  [59.779, 19.458, 0.02],
  [57.788, 19.284, 0.02],
  [55.798, 19.097, 0.02],
  [53.811, 18.89, 0.019],
  [51.826, 18.658, 0.015],
  [49.845, 18.394, 0.011],
  [47.868, 18.098, 0.01],
  [45.897, 17.769, 0.01],
  [43.931, 17.41, 0.01],
  [41.969, 17.03, 0.01],
  [40.01, 16.635, 0.01],
  [38.053, 16.233, 0.01],
  [36.095, 15.83, 0.01],
  [34.138, 15.425, 0.01],
  [32.182, 15.017, 0.01],
  [30.227, 14.604, 0.01],
  [28.273, 14.183, 0.01],
  [26.321, 13.757, 0.01],
  [24.368, 13.329, 0.01],
  [22.416, 12.904, 0.01],
  [20.462, 12.484, 0.01],
  [18.506, 12.073, 0.007],
  [16.548, 11.673, 0.003],
  [14.588, 11.286, 0],
  [12.624, 10.913, 0],
  [10.658, 10.554, 0],
  [8.69, 10.21, 0],
  [6.719, 9.88, 0],
  [4.746, 9.563, 0],
  [2.77, 9.259, 0],
  [0.793, 8.969, 0],
  [-1.186, 8.69, 0],
  [-3.166, 8.422, 0],
  [-5.148, 8.165, 0],
  [-7.131, 7.916, 0],
  [-9.115, 7.676, 0],
  [-11.1, 7.442, 0],
  [-13.085, 7.214, 0],
  [-15.071, 6.992, -0.001],
  [-17.057, 6.774, -0.005],
  [-19.044, 6.559, -0.009],
  [-21.032, 6.348, -0.01],
  [-23.019, 6.141, -0.01],
  [-25.007, 5.936, -0.01],
  [-26.995, 5.734, -0.01],
  [-28.984, 5.534, -0.01],
  [-30.972, 5.336, -0.01],
  [-32.961, 5.141, -0.01],
  [-34.95, 4.947, -0.01],
  [-36.94, 4.755, -0.01],
  [-38.929, 4.565, -0.01],
  [-40.918, 4.377, -0.01],
  [-42.908, 4.189, -0.01],
  [-44.898, 4.004, -0.01],
  [-46.888, 3.819, -0.01],
  [-48.878, 3.636, -0.01],
  [-50.868, 3.454, -0.013],
  [-52.858, 3.273, -0.017],
  [-54.849, 3.093, -0.02],
  [-56.839, 2.914, -0.02],
  [-58.83, 2.736, -0.02],
  [-60.82, 2.56, -0.02],
  [-62.811, 2.383, -0.02],
  [-64.802, 2.208, -0.02],
  [-66.792, 2.034, -0.02],
  [-68.783, 1.86, -0.02],
  [-70.774, 1.688, -0.02],
  [-72.765, 1.516, -0.02],
  [-74.756, 1.344, -0.02],
  [-76.748, 1.174, -0.02],
  [-78.739, 1.004, -0.02],
  [-80.73, 0.834, -0.023],
  [-82.721, 0.665, -0.027],
  [-84.713, 0.497, -0.03],
  [-86.704, 0.33, -0.03],
  [-88.696, 0.163, -0.03],
  [-90.687, -0.004, -0.03],
  [-92.679, -0.17, -0.03],
  [-94.67, -0.335, -0.03],
  [-96.662, -0.5, -0.03],
  [-98.653, -0.665, -0.03],
  [-100.645, -0.828, -0.03],
  [-102.637, -0.992, -0.03],
  [-104.629, -1.155, -0.03],
  [-106.621, -1.318, -0.03],
  [-108.612, -1.48, -0.03],
  [-110.604, -1.642, -0.03],
  [-112.596, -1.803, -0.03],
  [-114.588, -1.964, -0.031],
  [-116.58, -2.124, -0.035],
  [-118.572, -2.285, -0.039],
  [-120.564, -2.444, -0.04],
  [-122.556, -2.604, -0.04],
  [-124.548, -2.763, -0.04],
  [-126.541, -2.922, -0.04],
  [-128.533, -3.08, -0.04],
  [-130.525, -3.238, -0.04],
  [-132.517, -3.396, -0.04],
  [-134.509, -3.553, -0.04],
  [-136.502, -3.711, -0.04],
  [-138.494, -3.867, -0.04],
  [-140.486, -4.024, -0.04],
  [-142.478, -4.18, -0.04],
  [-144.471, -4.336, -0.04],
  [-146.463, -4.492, -0.04],
  [-148.456, -4.647, -0.04],
  [-150.448, -4.802, -0.043],
  [-152.44, -4.957, -0.047],
  [-154.433, -5.111, -0.05],
  [-156.425, -5.266, -0.05],
  [-158.418, -5.42, -0.05],
  [-160.41, -5.573, -0.05],
  [-162.403, -5.727, -0.05],
  [-164.396, -5.88, -0.05],
  [-166.388, -6.033, -0.05],
  [-168.381, -6.186, -0.05],
  [-170.373, -6.339, -0.05],
  [-172.366, -6.491, -0.05],
  [-174.359, -6.643, -0.05],
  [-176.351, -6.795, -0.05],
  [-178.344, -6.947, -0.05],
  [-180.337, -7.098, -0.053],
  [-182.329, -7.249, -0.057],
  [-184.322, -7.4, -0.06],
  [-186.315, -7.551, -0.06],
  [-188.308, -7.702, -0.06],
  [-190.3, -7.852, -0.06],
  [-192.293, -8.003, -0.06],
  [-194.286, -8.153, -0.06],
  [-196.279, -8.302, -0.06],
  [-198.272, -8.452, -0.06],
  [-200.265, -8.602, -0.06],
  [-202.257, -8.751, -0.06],
  [-204.25, -8.9, -0.06],
  [-206.243, -9.049, -0.06],
  [-208.236, -9.197, -0.06],
  [-210.229, -9.346, -0.06],
  [-212.222, -9.494, -0.06],
  [-214.215, -9.643, -0.061],
  [-216.208, -9.791, -0.065],
  [-218.201, -9.938, -0.069],
  [-220.194, -10.086, -0.07],
  [-222.187, -10.234, -0.07],
  [-224.18, -10.381, -0.07],
  [-226.173, -10.528, -0.07],
  [-228.166, -10.675, -0.07],
  [-230.159, -10.822, -0.07],
  [-232.152, -10.969, -0.07],
  [-234.145, -11.115, -0.07],
  [-236.138, -11.262, -0.07],
  [-238.131, -11.408, -0.07],
  [-240.124, -11.554, -0.07],
  [-242.117, -11.7, -0.07],
  [-244.11, -11.846, -0.07],
  [-246.104, -11.992, -0.07],
  [-248.097, -12.137, -0.07],
  [-250.09, -12.283, -0.072],
  [-252.083, -12.428, -0.076],
  [-254.076, -12.573, -0.08],
  [-256.069, -12.718, -0.08],
  [-258.063, -12.863, -0.08],
  [-260.056, -13.007, -0.08],
  [-262.049, -13.152, -0.08],
  [-264.042, -13.296, -0.08],
  [-266.035, -13.441, -0.08],
  [-268.029, -13.585, -0.08],
  [-270.022, -13.729, -0.08],
  [-272.015, -13.873, -0.08],
  [-274.008, -14.017, -0.08],
  [-276.002, -14.16, -0.08],
  [-277.995, -14.304, -0.08],
  [-279.988, -14.447, -0.082],
  [-281.982, -14.59, -0.086],
  [-283.975, -14.734, -0.09],
  [-285.968, -14.877, -0.09],
  [-287.962, -15.02, -0.09],
  [-289.955, -15.162, -0.09],
  [-291.948, -15.305, -0.09],
  [-293.942, -15.448, -0.09],
  [-295.935, -15.59, -0.09],
  [-297.928, -15.732, -0.09],
  [-299.922, -15.875, -0.09],
  [-301.915, -16.017, -0.09],
  [-303.909, -16.159, -0.09],
  [-305.902, -16.301, -0.094],
  [-307.895, -16.442, -0.098],
  [-309.889, -16.584, -0.1],
  [-311.882, -16.726, -0.1],
  [-313.876, -16.867, -0.1],
  [-315.869, -17.008, -0.104],
  [-317.863, -17.15, -0.108],
  [-319.856, -17.291, -0.112],
  [-321.849, -17.432, -0.116],
  [-323.843, -17.573, -0.12],
  [-325.836, -17.714, -0.124],
  [-327.83, -17.855, -0.128],
  [-329.823, -17.996, -0.132],
  [-331.817, -18.136, -0.136],
  [-333.81, -18.277, -0.141],
  [-335.804, -18.418, -0.149],
  [-337.797, -18.558, -0.157],
  [-339.791, -18.698, -0.165],
  [-341.784, -18.837, -0.173],
  [-343.778, -18.974, -0.181],
  [-345.772, -19.106, -0.189],
  [-347.767, -19.234, -0.197],
  [-349.761, -19.357, -0.207],
  [-351.756, -19.474, -0.219],
  [-353.751, -19.59, -0.231],
  [-355.746, -19.706, -0.243],
  [-357.741, -19.827, -0.255],
  [-359.736, -19.956, -0.265],
  [-361.729, -20.094, -0.273],
  [-363.722, -20.241, -0.281],
  [-365.715, -20.396, -0.293],
  [-367.707, -20.557, -0.305],
  [-369.698, -20.723, -0.317],
  [-371.689, -20.892, -0.329],
  [-373.68, -21.064, -0.341],
  [-375.671, -21.238, -0.353],
  [-377.662, -21.414, -0.365],
  [-379.653, -21.59, -0.377],
  [-381.643, -21.766, -0.389],
  [-383.634, -21.942, -0.401],
  [-385.625, -22.117, -0.409],
  [-387.616, -22.29, -0.417],
  [-389.607, -22.461, -0.425],
  [-391.598, -22.627, -0.433],
  [-393.59, -22.786, -0.441],
  [-395.583, -22.938, -0.449],
  [-397.576, -23.082, -0.457],
  [-399.57, -23.219, -0.462],
  [-401.564, -23.353, -0.466],
  [-403.558, -23.491, -0.471],
  [-405.551, -23.638, -0.479],
  [-407.543, -23.799, -0.487],
  [-409.533, -23.975, -0.492],
  [-411.523, -24.166, -0.496],
  [-413.511, -24.371, -0.5],
  [-415.498, -24.586, -0.504],
  [-417.483, -24.809, -0.508],
  [-419.469, -25.039, -0.51],
  [-421.453, -25.273, -0.51],
  [-423.437, -25.513, -0.511],
  [-425.421, -25.756, -0.515],
  [-427.404, -26.003, -0.519],
  [-429.387, -26.253, -0.52],
  [-431.369, -26.505, -0.52],
  [-433.351, -26.761, -0.52],
  [-435.333, -27.019, -0.52],
  [-437.314, -27.279, -0.52],
  [-439.296, -27.541, -0.52],
  [-441.276, -27.806, -0.52],
  [-443.257, -28.073, -0.52],
  [-445.237, -28.342, -0.52],
  [-447.217, -28.613, -0.52],
  [-449.197, -28.887, -0.52],
  [-451.176, -29.163, -0.52],
  [-453.155, -29.441, -0.52],
  [-455.134, -29.723, -0.52],
  [-457.112, -30.008, -0.52],
  [-459.089, -30.296, -0.52],
  [-461.066, -30.588, -0.52],
  [-463.043, -30.884, -0.519],
  [-465.019, -31.183, -0.515],
  [-466.994, -31.485, -0.511],
  [-468.969, -31.79, -0.51],
  [-470.944, -32.098, -0.51],
  [-472.918, -32.409, -0.509],
  [-474.892, -32.722, -0.505],
  [-476.865, -33.037, -0.502],
  [-478.838, -33.355, -0.498],
  [-480.811, -33.674, -0.494],
  [-482.783, -33.996, -0.49],
  [-484.755, -34.319, -0.49],
  [-486.727, -34.644, -0.49],
  [-488.699, -34.971, -0.488],
  [-490.67, -35.299, -0.484],
  [-492.641, -35.629, -0.48],
  [-494.612, -35.962, -0.476],
  [-496.582, -36.297, -0.472],
  [-498.551, -36.636, -0.468],
  [-500.52, -36.981, -0.464],
  [-502.487, -37.333, -0.46],
  [-504.453, -37.691, -0.456],
  [-506.418, -38.057, -0.452],
  [-508.381, -38.43, -0.446],
  [-510.343, -38.809, -0.438],
  [-512.304, -39.194, -0.43],
  [-514.262, -39.596, -0.426],
  [-516.214, -40.021, -0.422],
  [-518.163, -40.465, -0.418],
  [-520.108, -40.925, -0.414],
  [-522.05, -41.397, -0.41],
  [-523.99, -41.877, -0.403],
  [-525.928, -42.361, -0.395],
  [-527.867, -42.845, -0.387],
  [-529.807, -43.326, -0.379],
  [-531.749, -43.799, -0.371],
  [-533.693, -44.261, -0.36],
  [-535.641, -44.708, -0.348],
  [-537.593, -45.136, -0.338],
  [-539.55, -45.542, -0.33],
  [-541.512, -45.92, -0.322],
  [-543.48, -46.267, -0.311],
  [-545.454, -46.579, -0.299],
  [-547.434, -46.851, -0.287],
  [-549.419, -47.081, -0.275],
  [-551.409, -47.263, -0.263],
];

/** Where the pit lane meets the track and where the garages are (OSM-derived). */
export const SEPANG_PIT_META = {
  /** Lap distance on our centreline where the pit path starts (the entry road leaves the track). */
  entryS: 5157.857,
  /** Lap distance where the pit path ends (the exit road has rejoined the track). */
  exitS: 554.385,
  /** Pit building (garages) along the path, metres from the path start, and its front face offset right of the path. */
  garages: { from: 417.036, to: 766.977, frontOffset: 6.659 },
} as const;
